export interface MenuItem {
  label: string;
  onSelect?: () => void;
  disabled?: boolean;
  /** Renders a check mark column; undefined means "not checkable". */
  checked?: boolean;
  shortcut?: string;
  danger?: boolean;
  submenu?: MenuEntry[];
}

export type MenuEntry = MenuItem | { separator: true };

export function isSeparator(entry: MenuEntry): entry is { separator: true } {
  return 'separator' in entry;
}

/** Index of the next selectable entry in the given direction, wrapping; -1 if none. */
export function nextEnabledIndex(entries: readonly MenuEntry[], from: number, step: 1 | -1): number {
  const count = entries.length;
  for (let i = 1; i <= count; i++) {
    const index = (((from + step * i) % count) + count) % count;
    const entry = entries[index]!;
    if (!isSeparator(entry) && !entry.disabled) return index;
  }
  return -1;
}

/** Drops leading, trailing and doubled separators left behind by conditional entries. */
export function tidyMenu(entries: readonly (MenuEntry | null | false | undefined)[]): MenuEntry[] {
  const out: MenuEntry[] = [];
  for (const entry of entries) {
    if (!entry) continue;
    if (isSeparator(entry) && (out.length === 0 || isSeparator(out[out.length - 1]!))) continue;
    out.push(entry);
  }
  while (out.length > 0 && isSeparator(out[out.length - 1]!)) out.pop();
  return out;
}
